// Industry vocabulary for the dispatch board — gated, never hidden by CSS.
//   pest / lawn / general  → routes · techs · services
//   events                 → bookings · holds · rooms
//   landscaping / trades   → crews
import { getIndustryKey } from "../../../constants/uiRegistry";

const VOCAB = {
  pest_control: { route: "route", routes: "routes", worker: "tech", workers: "techs", stop: "stop", stops: "stops", service: "service", unassigned: "Unassigned", board: "Dispatch" },
  lawn:         { route: "route", routes: "routes", worker: "tech", workers: "techs", stop: "stop", stops: "stops", service: "service", unassigned: "Unassigned", board: "Dispatch" },
  general:      { route: "route", routes: "routes", worker: "tech", workers: "techs", stop: "stop", stops: "stops", service: "service", unassigned: "Unassigned", board: "Dispatch" },
  landscaping:  { route: "crew day", routes: "crews", worker: "crew", workers: "crews", stop: "job", stops: "jobs", service: "service", unassigned: "No crew yet", board: "Crews" },
  construction: { route: "crew day", routes: "crews", worker: "crew", workers: "crews", stop: "job", stops: "jobs", service: "scope", unassigned: "No crew yet", board: "Crews" },
  roofing:      { route: "crew day", routes: "crews", worker: "crew", workers: "crews", stop: "job", stops: "jobs", service: "scope", unassigned: "No crew yet", board: "Crews" },
  events:       { route: "room", routes: "rooms", worker: "coordinator", workers: "coordinators", stop: "booking", stops: "bookings", service: "package", unassigned: "Holds", board: "Bookings" },
};

export function getDispatchVocab(industryKey = getIndustryKey("general")) {
  const key = String(industryKey || "general").toLowerCase();
  return VOCAB[key] || VOCAB.general;
}

export const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
